import React, { useState, useEffect } from 'react';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Input from '@visa/vds/input';
import isValid from 'date-fns/isValid';
import Grid from '@visa/vds/grid';
import DateSelector from '@visa/vds/date-selector';
import { DateHelper } from '../../../../_helpers/DateHelper';
import Radio from '@visa/vds/radio';
import FormControl from '@visa/vds/form-control'
import MCSSpace from '../../../../components/MCSSpace';
import AnnouncementEditor from './AnnouncementEditor';
import AnnouncementRegionSelection from './AnnouncementRegionSelection';
import {FormErrorMessages} from '../../../../_constants/FormErrorMessages';
import MCSErrorText from '../../../../components/MCSErrorText';

function AnnouncementDetailsInput(props) {
    const labels = {
        start: `Publish Date`,
        end: `End Date`,
        invalidEnd: 'Error: Invalid end date',
        invalidOverlapEnd: 'Error: Selected date should be after start date',
        invalidOverlapStart: 'Error: Selected date should be before the end date',
        invalidStart: 'Error: Invalid start date',
        emptyStart: 'Error: this field cannot be empty. Please click on the calendar icon to select start date'
    }
    const [rangeType, setRangeType] = useState('start');
    const [rangeMinDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));

    useEffect(() => {
        handleValidation(rangeType);
    }); // eslint-disable-line

    const setAnnouncementName = (event) => {
        props.setAnnouncementNameValid(event.target.value.trim() != '')
        props.setAnnouncementDto({ ...props.announcementDto, announcementName: event.target.value })
    }

    const handleValidation = (type) => {
        const startDateStr = props.announcementDto.startDate;
        const endDateStr = props.announcementDto.endDate;

        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);

        if (startDateStr != null && endDateStr != null) {
            if (endDate < startDate) {
                if (type === "start") {
                    props.setInvalidStartDateErrorText(labels.invalidOverlapStart);
                } else if (type === "end") {
                    props.setInvalidEndDateErrorText(labels.invalidOverlapEnd);
                }
            }else{
                props.setInvalidStartDateErrorText("");
                props.setInvalidEndDateErrorText("");
            }
        }
    };

    const setEndDate = (endDate) => {
        props.setAnnouncementDto({ ...props.announcementDto, endDate: endDate });
    }

    const setStartDate = (startDate) => {
        props.setAnnouncementDto({ ...props.announcementDto, startDate: startDate })
    }

    const toggleUs = () => {
        props.setAnnouncementDto({ ...props.announcementDto, us: !props.announcementDto.us })
    }

    const toggleCanada = () => {
        props.setAnnouncementDto({ ...props.announcementDto, canada: !props.announcementDto.canada })
    }

    const toggleEu = () => {
        props.setAnnouncementDto({ ...props.announcementDto, eu: !props.announcementDto.eu })
    }

    const toggleAp = () => {
        props.setAnnouncementDto({ ...props.announcementDto, ap: !props.announcementDto.ap })
    }

    const toggleLac = () => {
        props.setAnnouncementDto({ ...props.announcementDto, lac: !props.announcementDto.lac })
    }

    const toggleCemea = () => {
        props.setAnnouncementDto({ ...props.announcementDto, cemea: !props.announcementDto.cemea })
    }

    const togglePublish = () => {
        props.setAnnouncementDto({ ...props.announcementDto, publishState: !props.announcementDto.publishState, startDate: null, endDate: null })
    }

    return(
        <Grid>
            <Row noGutter key={1}>
                <Col noTopGutter noGutter lg={12}>
                    <FormControl>
                        <Input
                            autoResize
                            label="Announcement Display Title"
                            name="Announcement"
                            id="Announcement"
                            onChange={setAnnouncementName}
                            errorText={FormErrorMessages.FieldCannotBeBlank}
                            helpText="This field is compulsory"
                            showHelpText
                            invalid={!props.isAnnouncementNameValid}
                            showErrorText
                            maxLength="99"
                            value={props.announcementDto.announcementName}
                        />
                    </FormControl>
                </Col>
            </Row>
            <MCSSpace />
            <AnnouncementEditor editorRef={props.editorRef} value={props.announcementDto.announcementDetails} />
            <MCSSpace height="2px" />
            {props.isEmptyAnnouncementDetails && <MCSErrorText text="Announcement Details cannot be blank"/>}
            <MCSSpace />
            <AnnouncementRegionSelection announcement={props.announcementDto}
                toggleUs={toggleUs} toggleCanada={toggleCanada} toggleAp={toggleAp}
                toggleCemea={toggleCemea} toggleLac={toggleLac} toggleEu={toggleEu}
            />

            <Row noGutter key={4} style={{ display: "inline" }}>
                <Radio
                    defaultChecked={props.announcementDto.publishState == null}
                    name="publishEnable"
                    label="Pending"
                    value="Pending"
                    onChange={togglePublish}
                />
                <Radio
                    defaultChecked={props.announcementDto.publishState == true}
                    name="publishEnable"
                    label="Publish"
                    value="Publish"
                    onChange={togglePublish}
                />
                <p style={{ fontSize: "13px" }}> Announcements that are "Pending" can only be viewed by VSS Admins. Only VSS Super Admins (SuAdmin) can update Announcements.</p>
            </Row>
            {props.announcementDto && props.announcementDto.publishState &&
                <Row noGutter key={5}>
                    <Col noTopGutter noGutter lg={6}>
                        <DateSelector
                            className="dateStyle"
                            ariaLabelCalendarButtonIcon={(date) => (
                                isValid(new Date(date))
                                    ? `Choose Start Date, selected start date is ${date}`
                                    : 'Choose Start Date'
                            )}
                            name="date-picker-before"
                            onSelect={date => {
                                setRangeType('start');
                                setStartDate(DateHelper.ToUTCDateTime(date));
                            }}
                            errorText={props.invalidStartDateErrorText}
                        invalid={props.invalidStartDateErrorText.trim().length > 0}
                            selectsStart
                            showErrorText
                            helpText="Click calendar icon to select start date. This field is compulsory"
                            showHelpText
                            label={labels.start}
                            minDate={rangeMinDate}
                            value={(props.announcementDto.startDate) ? DateHelper.ToLocaleDateString(props.announcementDto.startDate) : ''}
                        />
                    </Col>

                    <Col noTopGutter noGutter lg={6}>
                        <DateSelector
                            ariaLabelCalendarButtonIcon={(date) => (
                                isValid(new Date(date))
                                    ? `Choose End Date, selected end date is ${date}`
                                    : 'Choose End Date'
                            )}
                            name="date-picker-after"
                            onSelect={date => {
                                setRangeType('end');
                                setEndDate(DateHelper.ToUTCDateTime(date));
                            }}
                            errorText={props.invalidEndDateErrorText}
                            invalid={props.invalidEndDateErrorText.trim().length > 0}
                            selectsEnd
                            showErrorText
                            helpText="Click calendar icon to select date or enter backspace to leave date empty"
                            showHelpText
                            label={labels.end}
                            minDate={rangeMinDate}
                            value={(props.announcementDto.endDate) ? DateHelper.ToLocaleDateString(props.announcementDto.endDate) : ''}
                        />
                    </Col>
                </Row>
            }
        </Grid>
    );


}

export default AnnouncementDetailsInput